<template>
  <div>
           <vue-headful
            title="Login / Sign-up - Girish Jewellers"
            description="Login or signup, girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
                    <article class="content span12">
                <ul id="checkoutsteps" class="clearfix">
                    <li class="active">
                    
                    <div class="step-content">
                        <div class="col2-set clearfix">
                        <div class="col-1">
                            <h3 class="title">Login</h3>
                            <p>Already have an account, please log in.</p>
                            <label>Email Address: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.email.$error }">
                            <input class="input-block-level" id="email" name="email" type="email"  maxlength="100" v-model.trim="$v.results.email.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.email.$dirty && !$v.results.email.required">
                              Email is required
                            </span>

                            <label>Password: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.password.$error }">
                            <input id="password" name="password" class="input-block-level last" type="password" value="" maxlength="50" v-model.trim="$v.results.password.$model">
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.password.$dirty && !$v.results.password.required">
                              Password is required
                            </span>
                            <!-- .checkout-login -->
                            <div class="clearfix"></div>
                            <div class="buttons-box clearfix">
                                <button  type="button"  class="btn" v-on:click="submit" id="btnsubmit" name="btnsubmit">Login</button>
                            <router-link to="/forgot-password" style="color:#666;"  class="forgot">Forgot Your Password?</router-link>
                            <span class="required"><b>*</b> Required Field</span>
                            </div><!-- .buttons-box -->                                
                        </div>
                        <div class="col-2">
                            <h3 class="title">Sign-up</h3>
                            <p>By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.</p>

                            <div class="buttons-box clearfix">
                                <router-link class="btn"  to="/create-account">Create an Account</router-link>
                            </div>
                        </div>
                        </div>
                    </div>
                    </li>
                    </ul>
                    </article>
                </div>
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import { required} from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate';
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';

Vue.use(Vuelidate)

export default {
  name: 'Login',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
    this.getSession;
  },
  computed:mapGetters(["Session"]),
  watch:{
    Session(newValue) {
      if(newValue.is_login){
          this.get_submit_response(newValue)
        }
      },
},
beforeMount :function(){
      $("#email").focus();
      //Common.preparValidator(this.$v,'results');
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: {'email':'','password':''} };
    },
    validations: {
      results: {
      password: {
        required
      },
      email: {
        required
      }
      } 
    },    
    methods:{
    ...mapActions(["getSession","loginSession"]),
      isMobile:function(){
   return Common.isMobile();
   },
get_submit_response:function(response)
{ 

    //var rdata = JSON.parse(response);
    var rdata = response;
    //this.results = rdata;
    if(parseInt(rdata.id) > 0)
    {
      
      if(this.$route.query.f == 'checkout')
      {
        this.$router.push("/checkout");
      }else
      {
        this.$router.push("/account");
      }
        
    }

},submit: function()
{
    //this.errors.push("Name required.");
    //alert(this.results.$touch());
   
    this.$v.results.$touch();
    //alert(JSON.stringify(this.$v.results.password));

    if (this.$v.results.$pending || this.$v.results.$error) 
    {
      
      Common.showError("Invalid input, Please check the entered values again.");
      // 1. Loop the keys
        for (let key in Object.keys(this.$v.results)) {
          // 2. Extract the input
          const input = Object.keys(this.$v.results)[key];
          // 3. Remove special properties
          if (input.includes("$")) return false;
          // 4. Check for errors
          
          if (this.$v.results[input].$error) {
            // 5. Focus the input with the error
            $("#" + input).focus();

            // 6. Break out of the loop
            break;
          }

        }

      return;
    }
      // to form submit after this
      //Common.callServerFunction("Users/UserController::Login",this.get_submit_response,this.results,"Users");
      Common.startAjaxLoader();
      this.loginSession(this.results);
      
    //Common.showValidation(["Name required.","Address required.","Surname required."]);        
      },onResize: function() {
    },
      loadOnMount: function() {
        $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>